import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { getImageLocal } from '@/utils/locals';
import EFAppArrow from '@/components/UI/svg/Icons/EFAppArrow';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/deltapro/h5/');
export default function CardmsgD({}: any) {
    const { useLang, useRouter, Link } = useGlobal();
    const { t } = useLang('delta_pro_new');
    const { locale } = useRouter();
    const appImgLocal = getImageLocal(locale, ['jp', 'de', 'fr', 'cn']);
    const appRedirct = ['us', 'ca', 'uk', 'au', 'de', 'fr', 'jp', 'za', 'mx'];

    return (
        <div
            className={`${css.cardmsgD} cardmsgD2 GtmModuleData-section`}
            data-section-id={css.cardmsgD}
            data-section-title={t('wiredless_control')}
            style={{ height: '6.4rem' }}
        >
            <div className="card-msgs">
                <div className="card-title">{t('wiredless_control')}</div>
                <div className="card-desc">{t('wiredless_control_desc')}</div>
                {appRedirct.includes(locale) && (
                    <Link href="/app" className="link_learn" newWin>
                        <div className="text2">{t('learn_more')}</div>
                        <div className="icon">
                            <EFAppArrow />
                        </div>
                    </Link>
                )}
            </div>
            <div className="card-img" style={{ height: '6.4rem' }}>
                <EFPic
                    name={[`12WirelessControl_${appImgLocal}.webp`, `12WirelessControl_${appImgLocal}.jpg`]}
                    className="fullImgs"
                    alt={t('wiredless_control')}
                />
            </div>
        </div>
    );
}
